export const AUI_VERSION = '10.5.1';
export const AUI_LAST_UPDATE = '2021-01-20T00:15:41.465Z';
